import React from 'react'

function Developers() {
  return (
<>
      <h5 className='text-center'>About us</h5>
    <div className="dev-box py-2">
      <div className="dev-container-box">
        <div className="dev-box-img-box">
          <img className='dev-img' src="./image/developerImg.jpeg" alt="" />
        </div>
        <div className="dev-text-box text-center">
          <p className="dev-name-text">Ujjwal Kushwaha</p>
          <p className="dev-para-text">Hey I'm from FGP, contact me for Website Development & Management or other Technical issues at
            <strong> fgpujjwal@gmail.com
            </strong> </p>
        </div>
      </div>

      <div className="dev-container-box mx-2">
        <div className="dev-box-img-box">
          <img className='dev-img' src="./image/mm.jpeg" alt="" />
        </div>
        <div className="dev-text-box text-center">
          <p className="dev-name-text">Manash Mishra</p>
          <p className="dev-para-text">Hey I'm from FGP, contact me for Resource production, Notes, study materials & copyright issues at <strong>fgpmanash@gmail.com
          </strong></p>
        </div>
      </div>
    </div>
</>

  )
}

export default Developers;